
import BeneficiarioNoAfiliado from '@/models/BeneficiarioNoAfiliado';
import User from '@/models/User';
import AfiliadoService from '@/services/AfiliadoService';
import ServiceResponse from '@/services/response-models/ServiceResponse';
import VeeValidateForm from '@/vee-validate/types/VeeValidateForm';
import { AxiosResponse } from 'axios';
import { Component, Vue } from "vue-property-decorator";
import { Getter } from 'vuex-class';
import Swal from "sweetalert2";

@Component({})
export default class ActualizacionDatos extends Vue {
    @Getter("user") user: User;
    public actualizarDatos: boolean = false;
    public nuevoCorreoElectronico: string = null;
    public nuevoTelefonoCelular: string = null;
    public afiliadoService: AfiliadoService = new AfiliadoService();

    public mounted(): void {
        this.nuevoCorreoElectronico = this.user.correoElectronico1 || this.user.correoElectronico2;
        this.nuevoTelefonoCelular = this.user.celular;
    }

    public confirmarDatos(): void {
        (this.$refs.actualizacionDatosForm as VeeValidateForm)
            .validate()
            .then((isValid: boolean) => {
                Swal.fire({
                    text: "Se están registrando tus datos",
                    icon: "info",
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                    }
                });
                let beneficiarioNoAfiliado: BeneficiarioNoAfiliado = new BeneficiarioNoAfiliado();
                if (this.nuevoCorreoElectronico && this.nuevoCorreoElectronico.trim() !== '') {
                    beneficiarioNoAfiliado.correoElectronico1 = this.nuevoCorreoElectronico;
                }
                if (this.nuevoTelefonoCelular && this.nuevoTelefonoCelular.trim() !== '') {
                    beneficiarioNoAfiliado.celular = this.nuevoTelefonoCelular;
                }
                beneficiarioNoAfiliado.cedulaBeneficiario = this.user.cedula;
                this.afiliadoService.actualizarDatos(beneficiarioNoAfiliado).then((response: AxiosResponse<ServiceResponse>) => {
                    Swal.close();
                    if (response.data.respCode === 200) {
                        //Update User Data in Store
                        let user: User = Object.assign({}, this.user);
                        user.celular = this.nuevoTelefonoCelular
                        user.correoElectronico1 = this.nuevoCorreoElectronico;
                        this.$store.dispatch("updateUserInfo", user);

                        Swal.fire({
                            text: "Se actualizaron tus datos",
                            icon: "success",
                            showConfirmButton: false,
                            timer: 3000,
                            onClose: () => {
                                this.$router.push(
                                    "/registro-sobrevivencia"
                                );
                            }
                        });
                    } else {
                        Swal.fire({
                            text: "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde.",
                            icon: "error",
                            showConfirmButton: true,
                            confirmButtonText: "Ok",
                            onClose: () => {
                                
                            }
                        });
                    }
                })
            });
    }

    public navigateToRegistroFallecimiento(): void {
        this.$router.push("/registro-sobrevivencia");
    }
}
